import { API, Endpoints } from "@brg/api";
import { useProfile } from "@brg/auth";
import { useEffect, useState } from "react";

export const useIsBriefAvailable = () => {
    const [isUserApproved, setIsUserApproved] = useState<any>(undefined);
    const [userFlow, setUserFlow] = useState(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const profile = useProfile();
    const [error, setError] = useState<boolean>(false);

    useEffect(() => {
        if (profile) {
            setIsLoading(true);
            API.request()
                .endpoint(Endpoints.mnePw)
                .url(`/api/Account/${'GetMemberLegalEntities'}`)
                .get()
                .addQuery('IsLegalEntityApproved', 'true')
                .addQuery('BriefCompetitionFlow', 'all')
                .send()
                .then((d) => d.json())
                .then((d) => {
                    API.request()
                    .endpoint(Endpoints.mnePw)
                    .url(`/api/Account/${'GetLegalEntities'}`)
                    .get()
                    .addQuery('IsLegalEntityApproved', 'true')
                    .addQuery('BriefCompetitionFlow', 'all')
                    .send()
                    .then((r) => r.json())
                    .then((r) => {
                        const list = [...d, ...r]?.map(({ accountId }) => accountId );
                        const flow = [...d,...r]?.find(({ accountId }) => accountId === profile?.accountId )?.briefCompetitionFlow
                        setIsUserApproved(flow && list?.includes(profile?.accountId))
                        setUserFlow(flow)
                        setIsLoading(false);
                        setError(false);
                    })
                })
                .catch(r => console.error(r));
        }

    }, [profile])

    return [isUserApproved, userFlow]
}import { API, Endpoints } from "@brg/api";
import { useProfile } from "@brg/auth";
import { useEffect, useState } from "react";

export const useIsBriefAvailable = () => {
    const [isUserApproved, setIsUserApproved] = useState<any>(undefined);
    const [userFlow, setUserFlow] = useState(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const profile = useProfile();
    const [error, setError] = useState<boolean>(false);

    useEffect(() => {
        if (profile) {
            setIsLoading(true);
            API.request()
                .endpoint(Endpoints.mnePw)
                .url(`/api/Account/${'GetMemberLegalEntities'}`)
                .get()
                .addQuery('IsLegalEntityApproved', 'true')
                .addQuery('BriefCompetitionFlow', 'all')
                .send()
                .then((d) => d.json())
                .then((d) => {
                    API.request()
                    .endpoint(Endpoints.mnePw)
                    .url(`/api/Account/${'GetLegalEntities'}`)
                    .get()
                    .addQuery('IsLegalEntityApproved', 'true')
                    .addQuery('BriefCompetitionFlow', 'all')
                    .send()
                    .then((r) => r.json())
                    .then((r) => {
                        const list = [...d, ...r]?.map(({ accountId }) => accountId );
                        const flow = [...d,...r]?.find(({ accountId }) => accountId === profile?.accountId )?.briefCompetitionFlow
                        setIsUserApproved(flow && list?.includes(profile?.accountId))
                        setUserFlow(flow)
                        setIsLoading(false);
                        setError(false);
                    })
                })
                .catch(r => console.error(r));
        }

    }, [profile])

    return [isUserApproved, userFlow]
}